import React from "react";

import { cn } from "../../../utils/cn";

import Icon, { Icons } from "../Icon/Icon";
import Typography from "../Typography/Typography";

import styles from "./Tag.module.css";

export const Variants = {
    default: styles.TagDefault,
    info: styles.TagInfo,
    error: styles.TagError,
    warning: styles.TagWarning,
    success: styles.TagSuccess,
    transparent: "",
};

export const Sizes = {
    small: styles.TagSmall,
    medium: styles.TagMedium,
    large: styles.TagLarge,
};

export interface TagProps {
    variant?: keyof typeof Variants;
    children: React.ReactNode;
    className?: string;
    icon?: Icons;
    size?: keyof typeof Sizes;
    onClick?: () => void;
    title?: string;
}

const Tag = ({ variant = "default", size = "medium", children, icon, className, onClick, title }: TagProps) => {
    const classNames = cn(
        styles.tag,
        Variants[variant],
        Sizes[size],
        className
    );

    if (onClick) {
        return (
            <button type="button" className={classNames} onClick={onClick} title={title}>
                <Typography fontSize="040">{children}</Typography>
                {icon ? <Icon icon={icon} /> : null}
            </button>
        );
    }

    return (
        <div className={classNames}>
            <Typography fontSize="040">{children}</Typography>
            {icon ? <Icon icon={icon} /> : null}
        </div>
    );
};

export default Tag;
